module.exports = __webpack_public_path__ + "static/media/kernelcon_hilton10.ee8f62e4.jpg";